import React, {h, Component} from 'preact';

export default class SellOrBuyStep extends Component {
    chooseSell(alsoBuying) {
        this.props.parent.priceRangePromise = $.get('fetch-pricerange-json', {
            location: this.props.location,
            isMobile: true
        });
        trackEvent('Flow', 'buyOrSell', alsoBuying ? 'reqsellandbuy' : 'reqsell', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withOptimizely()
            .withGA();
        if (alsoBuying) {
            return this.props.parent.setState({currentStep: 'SELL_AND_BUY_ADDRESS_STEP', alsoBuying});
        }
        this.props.parent.setState({currentStep: 'SELL_EXPECTED_LIST_DATE', alsoBuying});
    }

    chooseBuy() {
        $.get('submitBuyDraftRequest-json', {
            location: this.props.location,
            dlink: this.props.dlink,
            tag: this.props.tag,
            isMobile: true
        }).then(data => {
            if (data.redirectUrl) {
                window.location = data.redirectUrl;
                return;
            }
            trackEvent('Flow', 'buyOrSell', 'reqbuy')
                .withOptimizely()
                .withGA();
            this.props.parent.setState(
                {
                    priceRanges: data.roundedBuyPriceRanges
                },
                () => {
                    this.props.parent.setState({
                        currentStep: 'BUY_PRICE_RANGE',
                        rebateSupported: data.req.rebateSupported,
                        isBuyer: true
                    });
                }
            );
        });
        this.props.parent.setState({currentStep: 'LOADING'});
    }

    componentDidMount() {
        trackEvent('Flow', 'buyOrSell', 'clientLoadedPre3TabsStep1')
            .withOptimizely()
            .withGA();
        trackEvent('Flow', 'buyOrSell', 'buyOrSell')
            .withOptimizely()
            .withGA();
        if (this.props.showAgentCount) {
            trackEvent('Flow', 'buyOrSell', 'showAgentCount')
                .withOptimizely()
                .withGA();
        } else {
            trackEvent('Flow', 'buyOrSell', 'hideAgentCount')
                .withOptimizely()
                .withGA();
        }

        if (!!this.props.clientType && this.props.tabbedFlow == '1') {
            trackEvent('Flow', 'buyOrSell', 'clientLoaded3TabsStep1')
                .withOptimizely()
                .withGA();
            switch (this.props.clientType) {
                case 'seller':
                    return this.chooseSell();
                case 'buyer':
                    return this.chooseBuy();
                case 'sellerandbuyer':
                    return this.chooseSell(true);
                default:
                    return;
            }
        }
    }

    render() {
        if (this.props.source === 'personaFlow') {
            this.props.isBuyer === true ? this.chooseBuy() : this.chooseSell();
            return;
        }

        return (
            <div className="flow-step">
                <div className="flow-step-text hidden-xs" style={this.props.showAgentCount ? '' : 'color: transparent'}>
                    {this.props.agentCount > 0 ? this.props.agentCount : 'We have'} agents in the{' '}
                    {this.props.city ? this.props.city : this.props.location} area ready to compete for you.
                </div>

                <div className="flow-step-header-text">
                    <strong>Find a Top Agent in {this.props.city ? this.props.city : this.props.location}</strong>
                </div>
                <div className="option-div">
                    <div onClick={() => this.chooseSell()} className="buy-or-sell-button sell-button ab-test">
                        <img src={global.imageBaseUrl + '/buysell/svg/sell-new.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <div className="button-header">
                                <span className="hidden-xs">I want to </span>
                                <br className="hidden-xs" />
                                SELL
                            </div>
                        </div>
                    </div>
                    <div onClick={() => this.chooseBuy()} className="buy-or-sell-button buy-button ab-test">
                        <img src={global.imageBaseUrl + '/buysell/svg/buy-new.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <div className="button-header">
                                <span className="hidden-xs">I want to </span>
                                <br className="hidden-xs" />
                                BUY
                            </div>
                        </div>
                    </div>
                    <div onClick={() => this.chooseSell(true)} className="buy-or-sell-button sell-buy-button ab-test">
                        <img src={global.imageBaseUrl + '/buysell/svg/home-sell-buy.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <div className="button-header">
                                <span className="hidden-xs">I want to </span>
                                <br className="hidden-xs" />
                                SELL and BUY
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flow-spacer" />
            </div>
        );
    }
}
